import { Box, Center, Stack, Text, useMantineTheme } from '@mantine/core'
import React, { useEffect, useState } from 'react'
import { Sparkles } from 'components/Icon/icons/Sparkles'

export const Loader = () => {
  const [status, setStatus] = useState('Uploading file...')
  const theme = useMantineTheme()

  useEffect(() => {
    const stages = [
      { duration: 3000, message: 'Parsing image data...' },
      { duration: 3500, message: 'Analyzing catalog matches...' },
    ]

    let currentStage = 0

    const runStage = () => {
      if (currentStage >= stages.length) {
        currentStage = 0
      }

      const stage = stages[currentStage]
      setStatus(stage.message)

      currentStage += 1

      setTimeout(runStage, 2 * stage.duration + 2 * Math.random())
    }

    runStage()
  }, [])

  return (
    <Center
      style={{
        minHeight: 400,
        flexDirection: 'column',
        padding: theme.spacing.xl,
      }}
    >
      {/* Glowing icon container */}
      <Box
        pos="relative"
        style={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          background: `linear-gradient(135deg, ${
            theme.colors.brand?.[6] || '#126554'
          }, ${theme.colors.brand?.[4] || '#18a67a'})`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: theme.shadows.md,
          animation: 'pulse 2s infinite',
        }}
      >
        <Sparkles />

        {/* Outer ping effect */}
        <Box
          pos="absolute"
          inset={0}
          style={{
            borderRadius: '50%',
            background: `linear-gradient(135deg, ${
              theme.colors.brand?.[6] || '#126554'
            }, ${theme.colors.brand?.[4] || '#18a67a'})`,
            opacity: 0.2,
            animation: 'ping 2s infinite',
          }}
        />
      </Box>

      <Stack align="center" gap="xs" mt="lg" maw={400}>
        <Text ta="center" fz="lg" fw={500}>
          {status}
        </Text>
        <Text ta="center" fz="sm" c="dimmed">
          AI is analyzing your image
        </Text>
      </Stack>

      {/* Simple keyframes for pulse and ping */}
      <style>{`
        @keyframes pulse {
          0%,
          100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.9;
          }
        }

        @keyframes ping {
          0% {
            transform: scale(1);
            opacity: 0.4;
          }
          75%,
          100% {
            transform: scale(1.8);
            opacity: 0;
          }
        }
      `}</style>
    </Center>
  )
}
